import React from 'react'
import Modal from '../../modals/confirmation'

const ConsentForm = ({
    title,
    description,
    children,
    onConfirm = () => {},
    confirmLabel = 'Let\'s Do It!',
    onCancel = () => {},
    cancelLabel = 'Snooze'
}) => {
    return (
        <Modal
            onConfirm={() => onConfirm()}
            onCancel={() => onCancel()}
            visible={true}
            title={title}
            confirmLabel={confirmLabel}
            cancelLabel={cancelLabel}
        >
            {description}
            {children}
        </Modal>
    )
}

export default ConsentForm
